<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />

        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />
        <!-- TODO แก้คำบอกหน้าด้านบน -->
        <div
          @click="goBack"
          v-if="isDetail"
          class="flex pl-8 my-2"
          style="cursor: pointer;"
        >
          <feather-icon
            v-show="!verticalNavMenuItemsMin"
            class="mr-2"
            :class="[{ rotate90: openItems }, 'feather-grp-header-arrow']"
            :icon="'ChevronLeftIcon'"
            svg-classes="w-10 h-10"
          />

          <p
            v-if="this.$route.path === '/createtask'"
            style="font-size:25px;font-weight:500"
          >
            เพิ่ม Task {{ this.$store.getters["create/getCompanyName"].name }}
          </p>
          <p
            v-else-if="this.$route.path.includes('/createtask/')"
            style="font-size:25px;font-weight:500"
          >
            แก้ไข Task {{ this.$store.getters["create/getCompanyName"].name }}
          </p>
          <p
            v-else-if="this.$route.path === '/createinvoice'"
            style="font-size:25px;font-weight:500"
          >
            สร้างใบแจ้งหนี้
          </p>
          <p
            v-else-if="this.$route.path.includes('/editinvoice')"
            style="font-size:25px;font-weight:500"
          >
            แก้ไขใบแจ้งหนี้
          </p>
          <p
            v-else-if="this.$route.path === '/createreceipt'"
            style="font-size:25px;font-weight:500"
          >
            สร้างใบเสร็จรับเงิน
          </p>
          <p
            v-else-if="this.$route.path.includes('/editreceipt')"
            style="font-size:25px;font-weight:500"
          >
            แก้ไขใบเสร็จรับเงิน
          </p>
          <p
            v-else-if="this.$route.path === '/createmember'"
            style="font-size:25px;font-weight:500"
          >
            สร้างสมาชิก
          </p>
          <p
            v-else-if="this.$route.path.includes('/createmember/')"
            style="font-size:25px;font-weight:500"
          >
            รายละเอียดสมาชิก
          </p>
          <p
            v-else-if="this.$route.path.includes('foldermanagement')"
            style="font-size:25px;font-weight:500"
          >
            จัดการเอกสาร
          </p>
          <p
            v-else-if="this.$route.path.includes('/email/invoice')"
            style="font-size:25px;font-weight:500"
          >
            ส่งอีเมลใบแจ้งหนี้
          </p>
          <p
            v-else-if="this.$route.path.includes('/email/receipt')"
            style="font-size:25px;font-weight:500"
          >
            ส่งอีเมลใบเสร็จรับเงิน
          </p>
          <p
            v-else-if="this.$route.path === '/createaccounting'"
            style="font-size:25px;font-weight:500"
          >
            เพิ่มผู้รับเงิน
          </p>
          <p
            v-else-if="this.$route.path === '/createbankpayment'"
            style="font-size:25px;font-weight:500"
          >
            เพิ่มบัญชีธนาคาร
          </p>
          <p
            v-else-if="this.$route.path.includes('/userfile/')"
            style="font-size:25px;font-weight:500"
          >
            ALL FILES
          </p>
          <p v-else style="font-size:25px;font-weight:500">
            Back
          </p>
        </div>
        <p v-else style="font-size:25px;font-weight:500" class="pl-8 my-2">
          {{ nowPage.toUpperCase() }}
        </p>
        <vs-spacer />

        <!-- <search-bar />

        <notification-drop-down />

        <profile-drop-down /> -->
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import { mapGetters } from "vuex";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
  },
  computed: {
    ...mapGetters({
      nowPage: "getNowPage",
      isDetail: "home/isDetailPage",
    }),
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isDetail() {
      if (
        this.$route.path === "/detail" ||
        this.$route.path.includes("/createtask") ||
        this.$route.path === "/createinvoice" ||
        this.$route.path.includes("/editinvoice") ||
        this.$route.path === "/createreceipt" ||
        this.$route.path.includes("/editreceipt") ||
        this.$route.path === "/createmember" ||
        this.$route.path.includes("/createmember/") ||
        this.$route.path === "/createaccounting" ||
        this.$route.path === "/createbankpayment" ||
        this.$route.path.includes("foldermanagement") ||
        this.$route.path.includes("email") ||
        this.$route.path.includes("/userfile/")
      ) {
        return true;
      } else return false;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default";
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    goBack() {
      // if (this.$route.path.includes("foldermanagement")) {
      //   this.$store.dispatch("create/popFolderLevelName");
      // }
      this.$router.go(-1);
    },
  },
};
</script>
